module.exports = __webpack_public_path__ + "img/body-1-lg.209e9984.png";